import {
  TrackingPageBlock,
  TrackingPageBlockType,
  TrackingPageGameBlock,
  TrackingPageHeaderBlock,
  TrackingPageItemsInFulfillmentBlock,
  TrackingPageProductUpsellBlock,
  TrackingPagePromotionBlock,
  TrackingPageSubscriptionUpsellBlock,
  TrackingPageTextBlock,
  TrackingPageTrackingDetailsBlock,
  TrackingPageTrackingUpdatesBlock,
} from "@redotech/redo-model/order-tracking/tracking-page-definition";
import { assertNever } from "@redotech/util/type";
import { memo } from "react";
import {
  WidgetEditorDecorator,
  WidgetProps,
  withEditor,
} from "../../form-builder/widget-editors/widget-editor-decorator";
import { GameBlock } from "../blocks/game/game";
import { Header } from "../blocks/header";
import { ItemsInFulfillment } from "../blocks/items-in-fulfillment";
import { ProductUpsell } from "../blocks/product-upsell/product-upsell";
import { Promotion } from "../blocks/promotion";
import { SubscriptionUpsell } from "../blocks/subscription-upsell";
import { TextBlock } from "../blocks/text-block";
import { TrackingDetails } from "../blocks/tracking-details/tracking-details";
import { TrackingUpdates } from "../blocks/tracking-updates";

export const TrackingPageBlockEditor = <T extends WidgetProps<E>, E>(
  props: WidgetEditorDecorator<T, E>,
) => {
  return (
    <div
      style={{
        backgroundColor: "transparent",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      {props.children(props)}
    </div>
  );
};
export const HeaderWithEditor = withEditor<
  WidgetProps<TrackingPageHeaderBlock>,
  TrackingPageHeaderBlock
>(TrackingPageBlockEditor, (props) => <Header {...props.element} />);

export const TrackingDetailsWithEditor = withEditor<
  WidgetProps<TrackingPageTrackingDetailsBlock>,
  TrackingPageTrackingDetailsBlock
>(TrackingPageBlockEditor, (props) => <TrackingDetails {...props.element} />);

export const ItemsInFulfillmentWithEditor = withEditor<
  WidgetProps<TrackingPageItemsInFulfillmentBlock>,
  TrackingPageItemsInFulfillmentBlock
>(TrackingPageBlockEditor, (props) => (
  <ItemsInFulfillment {...props.element} />
));

export const ProductUpsellWithEditor = withEditor<
  WidgetProps<TrackingPageProductUpsellBlock>,
  TrackingPageProductUpsellBlock
>(TrackingPageBlockEditor, (props) => <ProductUpsell {...props.element} />);

export const PromotionWithEditor = withEditor<
  WidgetProps<TrackingPagePromotionBlock>,
  TrackingPagePromotionBlock
>(TrackingPageBlockEditor, (props) => <Promotion {...props.element} />);

export const GameWithEditor = withEditor<
  WidgetProps<TrackingPageGameBlock>,
  TrackingPageGameBlock
>(TrackingPageBlockEditor, (props) => <GameBlock {...props.element} />);

export const SubscriptionUpsellWithEditor = withEditor<
  WidgetProps<TrackingPageSubscriptionUpsellBlock>,
  TrackingPageSubscriptionUpsellBlock
>(TrackingPageBlockEditor, (props) => (
  <SubscriptionUpsell {...props.element} />
));

export const TrackingUpdatesWithEditor = withEditor<
  WidgetProps<TrackingPageTrackingUpdatesBlock>,
  TrackingPageTrackingUpdatesBlock
>(TrackingPageBlockEditor, (props) => <TrackingUpdates {...props.element} />);

export const TextBlockWithEditor = withEditor<
  WidgetProps<TrackingPageTextBlock>,
  TrackingPageTextBlock
>(TrackingPageBlockEditor, (props) => <TextBlock {...props.element} />);

// Shared component for rendering block content
export const BlockContent = memo(function BlockContent({
  block,
  index,
  onUpdate,
}: {
  block: TrackingPageBlock;
  index: number;
  onUpdate: (block: TrackingPageBlock) => void;
}) {
  switch (block.type) {
    case TrackingPageBlockType.HEADER:
      return (
        <HeaderWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.TRACKING_DETAILS:
      return (
        <TrackingDetailsWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.ITEMS_IN_FULFILLMENT:
      return (
        <ItemsInFulfillmentWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.PRODUCT_UPSELL:
      return (
        <ProductUpsellWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.PROMOTION:
      return (
        <PromotionWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.GAME:
      return (
        <GameWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.SUBSCRIPTION_UPSELL:
      return (
        <SubscriptionUpsellWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.TRACKING_UPDATES:
      return (
        <TrackingUpdatesWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    case TrackingPageBlockType.TEXT:
      return (
        <TextBlockWithEditor
          index={index}
          key={block._id}
          onSelectElement={() => {}}
          selected={false}
          setElement={onUpdate}
          widget={{ element: block }}
        />
      );
    default:
      assertNever(block);
  }
});
